var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClearFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20.662,
  height: 19.061
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Clear Filter"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon feather-filter",
  d: "M18.916.75H.75l7.266 8.593v5.94L11.65 17.1V9.343Z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon ionic-ios-close-circle",
  d: "M14.747 7.23a5.915 5.915 0 1 0 5.915 5.915 5.914 5.914 0 0 0-5.915-5.915Zm1.5 8.056-1.5-1.5-1.5 1.5a.455.455 0 1 1-.643-.643l1.5-1.5-1.5-1.5a.455.455 0 0 1 .643-.643l1.5 1.5 1.5-1.5a.455.455 0 0 1 .643.643l-1.5 1.5 1.5 1.5a.457.457 0 0 1 0 .643.451.451 0 0 1-.644 0Z"
}))));
export default SvgClearFilter;